import Typography from '@mui/material/Typography';
import RefreshIcon from '@mui/icons-material/Refresh';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import colors from 'styles/colors';

const JobsTitle = ({ refetch }) => (
  <Box sx={{ display: 'flex', alignItems: 'end' }}>
    <Typography
      variant="h4"
      sx={{ color: colors.text.primary }}
    >
      Jobs
    </Typography>
    <IconButton
      onClick={refetch}
      sx={{ paddingBottom: '3px' }}
    >
      <RefreshIcon
        fontSize="small"
        sx={{
          color: colors.text.primary,
          '&:hover': {
            color: colors.text.secondary,
          },
        }}
      />
    </IconButton>
  </Box>
);

export default JobsTitle;
